import styled from 'styled-components'
const FlagSign = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='22.732'
    height='15.279'
    viewBox='0 0 22.732 15.279'
  >
    <defs>
      <style>{'.b{fill:#fff;}'}</style>
    </defs>
    <g transform='translate(0 0)'>
      <ASign className='a' width='22.732' height='15.279' transform='translate(0)' />
    </g>
    <g transform='translate(4.601 0.657)'>
      <path
        className='b'
        d='M27.616,26.026c-.084.589-.169.841-.253.841,0,.084-.084.084-.168.084s-.084-.084-.084-.168a5.542,5.542,0,0,0,.168-.757,1.5,1.5,0,0,0-.168-.925c0-.084,0-.168.084-.168h.168v.084a2.05,2.05,0,0,1,.169,1.093Z'
        transform='translate(-13.883 -19.383)'
      />
      <path
        className='b'
        d='M26.631,26.667c0,.084-.084.084-.168.084s-.084-.084-.084-.168a2.636,2.636,0,0,0,.084-.756,2.008,2.008,0,0,0-.252-.926c0-.084,0-.168.084-.168h.168a2.737,2.737,0,0,1,.252,1.093c0,.589-.084.841-.168.841Z'
        transform='translate(-13.74 -19.352)'
      />
      <path
        className='b'
        d='M24.488,26.108c-.252,1.009-.673,1.85-.757,2.187a3.341,3.341,0,0,0-.169,1.85,11.459,11.459,0,0,1-.084,2.1c0,.168-.168.252-.336.252s-.252-.085-.336-.336c-.084-.42-.252-2.186-.252-2.438a.375.375,0,0,0-.252-.336c-.084,0-.168.084-.252.42-.168.757-.42,2.606-.5,3.026s-.253.505-.337.505h-.084A.3.3,0,0,1,20.786,33c0-.42.336-2.943.336-3.2,0-.168,0-.252-.084-.252s-.084.084-.168.168c-.252.336-1.429,2.438-1.767,3.111-.084.168-.168.168-.336.168a.309.309,0,0,1-.252-.084c-.084-.084-.252-.336-.168-.5s1.262-2.859,1.43-3.2c.084-.252.084-.42-.084-.42-.084,0-.168.084-.337.168-.42.42-2.018,2.1-2.271,2.27-.084.084-.168.168-.252.168s-.168-.084-.252-.168a.4.4,0,0,1-.084-.5,37.225,37.225,0,0,0,2.523-3.447c.336-.589.842-1.6-.168-1.6h-.168c-.42,0-.673.084-.925.084a3.2,3.2,0,0,1-.674-.084c-.168-.084-.5-.252-.42-.5.084-.168.589-.084.842-.168l.168-.084a7.96,7.96,0,0,0,1.513-.589,9.207,9.207,0,0,1,2.271-.925c.169,0,.337-.084.505-.084.252,0,.5,0,.589.084.252.084.5.757,1.683,1.261a1.6,1.6,0,0,1,.252,1.514Z'
        transform='translate(-12.185 -19.129)'
      />
      <path
        className='b'
        d='M13.84,27.162a9.367,9.367,0,0,1-.5-2.27,4.788,4.788,0,0,0-.841-1.6A11.09,11.09,0,0,1,11.4,21.528c-.084-.168.084-.42.336-.42.084,0,.168,0,.252.168.336.336,1.43,1.682,1.6,1.851a.637.637,0,0,0,.336.168c.168,0,.168-.085.084-.5-.252-.757-1.093-2.438-1.261-2.775-.252-.589.084-.589.084-.589A.294.294,0,0,1,13,19.343c.084,0,.168,0,.252.168.168.335,1.346,2.69,1.514,2.858.084.085.168.168.252.168s.084-.084.084-.252c0-.42-.168-2.775-.252-3.532a.45.45,0,0,1,.42-.42h0a.559.559,0,0,1,.42.336c.084.168.5,3.111.589,3.532a.375.375,0,0,0,.252.336c.084,0,.169-.084.253-.336.084-.589.589-2.859.589-3.111a.308.308,0,0,1,.336-.336h.084a.385.385,0,0,1,.336.42c0,.252-.252,3.111-.168,4.036a3.865,3.865,0,0,1-1.093.336h0l-.168.084h-.169a1.066,1.066,0,0,0-1.093.5,1,1,0,0,0-.084.673c.168.42.673.673.757.757h0a1.963,1.963,0,0,0,.926.168,4.126,4.126,0,0,0,.925-.084l-.252.5-.084.084c-.168.252-.673,1.009-1.514,2.1h-.42a2.328,2.328,0,0,0-.757.084s-.674-.084-1.094-1.093Z'
        transform='translate(-11.379 -18.333)'
      />
      <path
        className='b'
        d='M14.82,30.747c0,.084-.085.084-.169.084h-.084a1.809,1.809,0,0,1-.841-.673,3.716,3.716,0,0,1-.42-.757c0-.084,0-.167.084-.167s.168,0,.168.084a3.834,3.834,0,0,0,.336.673,2.067,2.067,0,0,0,.757.589c.085,0,.085.084.085.168Z'
        transform='translate(-11.686 -20.068)'
      />
      <path
        className='b'
        d='M13.967,31.115a.082.082,0,0,1-.084.084H13.8a1.877,1.877,0,0,1-.757-.757,1.474,1.474,0,0,1-.336-.841.294.294,0,0,1,.084-.168.294.294,0,0,1,.168.084,1.248,1.248,0,0,0,.336.673,2.2,2.2,0,0,0,.673.673c.084,0,.084.085.084.169Z'
        transform='translate(-11.59 -20.1)'
      />
    </g>
  </svg>
)
const ASign = styled.rect`
  fill: #bdc3c7;
`
export { FlagSign }
